/**
 * TutorialTestBanner — Persistent banner shown when in tutorial test mode.
 * "End Test" deletes the temp account and closes the tab.
 */
import { useState, useCallback } from 'react';
import apiClient from '../api/client';

export default function TutorialTestBanner() {
  const [ending, setEnding] = useState(false);
  const isTestMode = !!sessionStorage.getItem('tutorial_test_token');

  const endTest = useCallback(async () => {
    setEnding(true);
    const userId = sessionStorage.getItem('tutorial_test_user_id');
    try {
      if (userId) {
        await apiClient.delete(`/api/auth/tutorial-test/${userId}`);
      }
    } catch (err) {
      console.warn('Failed to delete tutorial test account:', err);
    }
    // Clean up
    sessionStorage.removeItem('tutorial_test_token');
    sessionStorage.removeItem('tutorial_test_user_id');
    sessionStorage.removeItem('tutorial_test_mode');
    // Do NOT touch localStorage — it would affect admin's tutorial state in other tabs
    // Close the tab (works if we opened it)
    window.close();
    // Fallback if window.close() is blocked
    setTimeout(() => {
      document.body.innerHTML = '<p style="color:#94a3b8;padding:2rem;font-family:system-ui;">Tutorial test ended. You can close this tab.</p>';
    }, 500);
  }, []);

  if (!isTestMode) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 99999,
      background: 'linear-gradient(90deg, #1e1b4b, #312e81)',
      borderBottom: '1px solid rgba(99, 102, 241, 0.4)',
      padding: '6px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
      fontFamily: 'system-ui, sans-serif',
      fontSize: '13px',
      color: '#a5b4fc',
    }}>
      <span style={{
        background: 'rgba(99, 102, 241, 0.2)',
        border: '1px solid rgba(99, 102, 241, 0.3)',
        borderRadius: '4px',
        padding: '1px 6px',
        fontSize: '11px',
        fontWeight: 600,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        color: '#818cf8',
      }}>
        TEST
      </span>
      <span>Test mode: temporary account, no data persists</span>
      <button
        onClick={endTest}
        disabled={ending}
        style={{
          marginLeft: '8px',
          background: 'rgba(239, 68, 68, 0.15)',
          border: '1px solid rgba(239, 68, 68, 0.3)',
          borderRadius: '4px',
          padding: '3px 10px',
          color: '#fca5a5',
          fontSize: '12px',
          fontWeight: 600,
          cursor: ending ? 'wait' : 'pointer',
          opacity: ending ? 0.5 : 1,
        }}
      >
        {ending ? 'Cleaning up...' : 'End Test'}
      </button>
    </div>
  );
}
